import React, { useEffect, useMemo } from "react";
import usePropertyConflictCheckerModal from "./modal/usePropertyConflictCheckerModal";
import { useWatch } from "react-hook-form";
import { HGetValueFromArray } from "@rf-helper/get-value-from-array";
import HCheckArray from "@rf-helper/check-have-value";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import usePropertyHelpTypeLocations from "../helps/usePropertyHelpTypeLocations";
import { debounce } from "lodash";
import { ownerAutoCompleteItem } from "@rf/adapters/autocomplete-items/ownerItemAdapters";
import { CPropertyFormKeys } from "../../util/schemas/property-schema/propertySchema";

/**
 * hook to check the conflict of the property form
 * Type Observers
 * @returns
 */
const usePropertyCheckConflict = () => {
  const { isProject } = usePropertyHelpTypeLocations();

  const { handleConflictCheckerPropertyModal } = usePropertyConflictCheckerModal();
  const [
    type_property,
    sector_property,
    city_property,
    owners_property,
    id_property
  ] = useWatch({
    name: [
      CPropertyFormKeys.type_property,
      CPropertyFormKeys.sector_property,
      CPropertyFormKeys.city_property,
      CPropertyFormKeys.owners_property,
      CPropertyFormKeys.id_property
    ]
  });

  const handleCheckConflict = () => {
    const state: any = {
      ownersId: [],
      propertyTypeId: undefined,
      projectTypeId: undefined,
      sectorId: undefined,
      cityId: undefined,
      propertyIdToIgnore: id_property
    };

    state.projectTypeId = isProject
      ? HGetValueFromArray(type_property, "id")
      : undefined;

    state.propertyTypeId = !isProject ? HGetValueFromArray(type_property, "id") : 14;

    HCheckArray(owners_property) &&
      owners_property.forEach((element: ownerAutoCompleteItem) => {
        if (element?.extraData?.ownerData?.formData == null) {
          state.ownersId.push(element.value);
        }
      });

    state.sectorId = HGetValueFromArray(sector_property, "value");
    state.cityId = HGetValueFromArray(city_property, "value");
    return state;
  };

  const state = useMemo(() => {
    if (
      HCheckArray(type_property) &&
      HCheckArray(sector_property) &&
      HCheckArray(city_property) &&
      HCheckArray(owners_property)
    ) {
      return handleCheckConflict();
    } else {
      return null;
    }
  }, [
    JSON.stringify({
      type_property,
      sector_property,
      city_property,
      owners_property
    })
  ]);
  const handleOpenModal = debounce(() => {
    handleConflictCheckerPropertyModal(state);
  }, 500);

  useEffect(() => {
    if (state) {
      handleOpenModal();
    }
  }, [JSON.stringify(state)]);

  return;
};

export default usePropertyCheckConflict;
